import {Navigate, Route, Routes} from 'react-router-dom';
import {EditDomainHostingPage} from '../pages/edit-domain-hosting-page/edit-domain-hosting-page';

export const DomainHostingRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EditDomainHostingPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
